import React from "react";
import Chart from "react-apexcharts";

export default function DropOffLineChart({ series = [], weeks = [] }) {

  // Format weeks for display
  const weekLabels = weeks.map((week, index) => {
    if (!week) return `Week ${index + 1}`;
    const date = new Date(week);
    return `Week ${date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`;
  });

  const options = {
    chart: {
      type: "line",
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    stroke: {
      width: 3,
      curve: "smooth",
    },
    markers: {
      size: 5,
      hover: { size: 7 },
    },
    colors: ["#6366F1", "#F59E0B", "#10B981", "#EF4444", "#8B5CF6"],
    xaxis: {
      categories: weekLabels.length > 0 ? weekLabels : ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5"],
      labels: { style: { fontSize: "13px" } },
    },
    yaxis: {
      title: { text: "Avg. Gap between sessions (minutes)" },
      labels: { style: { fontSize: "13px" } },
    },
    legend: {
      position: "bottom",
      fontSize: "14px",
    },
    tooltip: {
      y: {
        formatter: (value) => `${value.toFixed(2)} min`
      }
    }
  };

  // Use provided series or default
  const chartSeries = series.length > 0 ? series : [
    {
      name: "Alpha Retail",
      data: [48, 45, 42, 40, 38],
    },
    {
      name: "Beta Corp",
      data: [62, 58, 55, 53, 49],
    },
  ];

  return (
    <Chart options={options} series={chartSeries} type="line" height={350} />
  );
}
